var map = {
	"./404_smile.svg": "ab07",
	"./AV_logo.svg": "95d7",
	"./bobSepticFinalScreenSubtitle.svg": "de77",
	"./bobSepticFinalScreenTitle.svg": "6e74",
	"./bobSepticFirstScreenSubtitle.svg": "8dd0",
	"./bobSepticFirstScreenTitle.svg": "7c7a",
	"./bobSepticSecondScreenSubtitle.svg": "745e",
	"./bobSepticSecondScreenTitle.svg": "3509",
	"./bs_finger.svg": "f4e7",
	"./bs_happy.svg": "1b58",
	"./bs_logo.svg": "3d3b",
	"./bs_sad.svg": "e3f8",
	"./check.png": "e209",
	"./check.svg": "7bae",
	"./clipboard-text-clock.svg": "cb8f",
	"./confetti.svg": "3311",
	"./fb-light.svg": "5645",
	"./google-light.svg": "cd6a",
	"./ic_adopt.png": "4004",
	"./ic_adopt_light.png": "9bb9",
	"./ic_backspace.svg": "9ae2",
	"./ic_camera_add.svg": "86c6",
	"./ic_capterra.svg": "6068",
	"./ic_capterra_light.svg": "6f1d",
	"./ic_checkbox.svg": "955b",
	"./ic_checkbox_checked.svg": "ba02",
	"./ic_close.svg": "e688",
	"./ic_close_white.svg": "0bc4",
	"./ic_comment_modal.svg": "0622",
	"./ic_content-save.svg": "bef0",
	"./ic_donate.svg": "0395",
	"./ic_donate_light.svg": "4d58",
	"./ic_facebook_color.svg": "df5e",
	"./ic_facebook_logo.svg": "c71b",
	"./ic_gift_giveaway.svg": "e354",
	"./ic_gift_giveaway_no_background.svg": "bbb7",
	"./ic_google.svg": "2cfa",
	"./ic_google_logo.svg": "9044",
	"./ic_instagram_color.svg": "34ef",
	"./ic_instagram_light.svg": "8da8",
	"./ic_photo.svg": "f72d",
	"./ic_send.svg": "df60",
	"./ic_success.svg": "29b6",
	"./ic_trash.svg": "0a8c",
	"./ic_tripadvisor_color.svg": "ab51",
	"./ic_trustpilot.svg": "d275",
	"./ic_trustpilot_light.svg": "d066",
	"./ic_vk_color.svg": "3de6",
	"./ic_vk_light.svg": "28a6",
	"./ic_web_color.svg": "cc78",
	"./ic_web_light.svg": "fde6",
	"./ic_yelp.svg": "8fd0",
	"./jbar-logo.png": "7edb",
	"./logo_mini.svg": "64d8",
	"./m&k_logo.png": "65a4",
	"./microphone_record.svg": "1fd9",
	"./photo_btn_img.png": "ff2c",
	"./profile_icon.svg": "c177",
	"./rect_close_img.png": "bbcb",
	"./sec__background.png": "cd0f",
	"./smile.svg": "0c16",
	"./stop_record_icon.svg": "8b33",
	"./tripadvisor-light.svg": "1a33",
	"./wasted_logo.jpg": "4031",
	"./yelp-light.svg": "13e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";